import React from 'react';

import {Alert} from 'src/design/atoms/Alert';
import {IconBan, IconCheck, IconExclamationCircle} from '@tabler/icons-react';
import type {PersonnelResponse} from 'src/api/ProactApiClient';
import {UserStatusEnum} from 'src/api/ProactApiClient';

export interface PersonnelStatusBannerProps {
  item?: PersonnelResponse;
}

const statusTitles: Record<UserStatusEnum, string> = {
  [UserStatusEnum.Active]: 'Active User',
  [UserStatusEnum.Inactive]: 'Inactive User',
  [UserStatusEnum.Pending]: 'Pending User',
};

const getFlags = (item: PersonnelResponse): string[] => [
  ...(item.isBannedOnProperty ? ['Banned on Property'] : []),
  ...(item.isSuspended ? ['Suspended'] : []),
  ...(item.isLeaveOfAbsence ? ['Leave of Absence'] : []),
  ...(item.isEligible === false ? ['Ineligible'] : []),
];

export const PersonnelStatusBanner: React.FC<PersonnelStatusBannerProps> = ({
  item,
}) => {
  if (item?.active == null || !(item.active in statusTitles)) return null;

  const flags = getFlags(item);
  const title = [statusTitles[item.active], ...flags].join(' | ');

  if (item.isBannedOnProperty) {
    return (
      <Alert
        mt="md"
        color="red"
        variant="filled"
        title={title}
        icon={<IconBan />}
      />
    );
  }

  const hasFlags = flags.length > 0;
  const activeColor = hasFlags ? 'orange' : 'green';
  const colorByStatus: Record<UserStatusEnum, string> = {
    [UserStatusEnum.Active]: activeColor,
    [UserStatusEnum.Inactive]: 'yellow',
    [UserStatusEnum.Pending]: 'blue',
  };
  const icon =
    item.active === UserStatusEnum.Active ? (
      <IconCheck />
    ) : (
      <IconExclamationCircle />
    );

  return (
    <Alert
      mt="md"
      color={colorByStatus[item.active]}
      variant="light"
      title={title}
      icon={icon}
    />
  );
};
